import type { PerfectScrollbarProps } from '@/components/PerfectScrollbar/PerfectScrollbar.types';

export const scrollbarOptions: PerfectScrollbarProps['options'] = {
  suppressScrollX: true,
  wheelPropagation: false,
};
